import makeApiCall from "../master/axiosIndex";
const boqApis = {
  fetchConsumptionTarget: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/inventory/consumptionTarget/list",
      method: "get",
      params,
    }),
  newConsumptionTarget: (data: any): Promise<any> =>
    makeApiCall({
      url: "/inventory/consumptionTarget/new",
      method: "post",
      data,
    }),

  checkConsumptionTargetValidity: (data: any): Promise<any> =>
    makeApiCall({
      url: "/inventory/consumptionTarget/checkValidHeader",
      method: "post",
      data,
    }),

  fetchViewDeatils: (targetId: any): Promise<any> =>
    makeApiCall<any>({
      url: "/inventory/consumptionTarget/view",
      method: "get",
      params: { targetId },
    }),

  newVersionboq: (data: any, targetId?: number) =>
    makeApiCall({
      url: "/inventory/consumptionTarget/update",
      method: "put",
      params: targetId ? { targetId } : undefined,
      data,
    }),

  fetchConsumptionTargetMaterialDeviationsList: ({
    sortOrder,
    pageSize,
    direction,
    pageDiff,
    paginationId,
    deviation,
    siteIds,
    blockIds,
  }: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/consumptionTargetMaterialDeviationsList",
      params: {
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        deviation,
        siteIds,
        blockIds,
      },
    }),

  fetchContractorBoqDropdown: (params: {
    siteIds: string;
    contractorIds?: string;
    budgetRemainingQty?: number;
  }): Promise<any> =>
    makeApiCall<any>({
      url: "/inventory/consumptionTarget/contractorBoqDropdown",
      method: "get",
      params,
    }),

  bulkUpload: (file: File, body: any = {}): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("body", JSON.stringify(body));

    return makeApiCall({
      url: `/inventory/consumptionTarget/bulk-upload`,
      method: "post",
      data: formData,
    });
  },
};

export default boqApis;
